import { useContext } from 'react';
import { InvitesContext, InvitesContextData } from './context';

export function useInvites(): InvitesContextData {
    const data = useContext<InvitesContextData | undefined>(InvitesContext);

    if (!data) {
        throw new Error(
            "InvitesContext unavailable. Are you sure you're using this in a nested component of an InvitesContextProvider?"
        );
    }

    return data;
}
